export default {"src":"/_next/static/media/savingscalc.e9cbf360.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};